import backendURLs from './backendApps'
import constants  from './constants'
import iframeApps from  './iframeApps'

const configurations = {
    ...constants,
    ...iframeApps,
    ...backendURLs
}

export const MARKETPLACE_URLS = {
  PRODUCTION: ['https://marketplace.gohighlevel.com', 'https://marketplace.leadconnectorhq.com'],
  STAGING: ['https://staging.marketplace.gohighlevel.com', 'https://staging.marketplace.leadconnectorhq.com'],
  INTEROP: ['https://staging.marketplace.gohighlevel.com', 'https://staging.marketplace.leadconnectorhq.com']
} as const;

export default configurations
